var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 14.375V12.9375H15.8125V14.375H12.9375ZM20.125 12.9375V14.375H17.25V12.9375H20.125ZM12.9375 11.5V10.0625H15.8125V11.5H12.9375ZM20.125 10.0625V11.5H17.25V10.0625H20.125ZM12.9375 17.25V15.8125H15.8125V17.25H12.9375ZM20.125 15.8125V17.25H17.25V15.8125H20.125ZM12.9375 20.125V18.6875H15.8125V20.125H12.9375ZM20.125 18.6875V20.125H17.25V18.6875H20.125ZM16.3853 0L23 6.61475V23H4.3125V19.2266L0 18.5415V5.75L4.3125 5.13232V0H16.3853ZM5.03125 13.1958H5.05371L6.42383 15.8125H8.31055L6.13184 12.1851L8.25439 8.625H6.47998L5.10986 11.208H5.0874L3.88574 8.625H1.94287L4.00928 12.2188L1.75195 15.8125H3.6499L5.03125 13.1958ZM21.5625 21.5625V8.625H12.9375V7.1875H14.375V5.75H12.9375V4.3125H14.375V1.4375H5.75V4.93018L10.0625 4.3125V20.125L5.75 19.4512V21.5625H21.5625ZM15.8125 7.1875H21.5625L15.8125 1.4375V7.1875Z",
    fill: "#D12232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportHead);
export default __webpack_public_path__ + "static/media/import-head.36100be4a35e0b3c30fac86da59610d8.svg";
export { ForwardRef as ReactComponent };